import React, { useEffect, useState } from "react";
import useEditorStore from "@/store/useEditorStore";
import FlowTabs from "./FlowTabs";
import { message } from "antd";

import useWscCustomFormModal from '@/component/UseWscCustomForm';
// import RustWebSocket from "./WebSocket";
import {useWsClient} from "./useWsClient";
import DebugWindow from "./DebugWindow";

function RustEditor() {
  const load_flow_data = useEditorStore.use.load_flow_data();
  const updateNodeProps = useEditorStore.use.updateNodeProps();
  const { showDynamicModal, hide, WscCustomFormModal } = useWscCustomFormModal();
  const loading = useEditorStore.use.loading();
  const isDeploying = useEditorStore.use.isDeploying();

  const [formid, setFormId] = useState(null);


  useEffect(() => {
    load_flow_data();
  }, []);

  const onDbClick = (node) => {
    if (!node.formid) message.error({ content: "节点注册信息缺失FormId" });
    else {
      setFormId(node.formid);
      showDynamicModal(node.formid, node);
    }
  };

  return (
    <div className="relative">
      {loading && (
        <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="text-white">{isDeploying ? "正在部署..." : "正在加载中..."}</div>
        </div>
      )}
      <FlowTabs
        onDbClick={onDbClick}
        formid={formid}
        updateNodeProps={updateNodeProps}
        hide={hide}
      />
      {/* 添加调试窗口 */}
      {/*<DebugWindow*/}
      {/*  messages={debugMessages}*/}
      {/*  onClear={clearDebugMessages}*/}
      {/*  connectionStatus={connectionStatus}*/}
      {/*/>*/}
      <DebugWindow />
    </div>
  );
}

export default RustEditor;
